import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

export function generateSignature(secretKey:any) {
  const currentTime = Math.floor(Date.now() / 60000); // Time in minutes
  const message = `time=${currentTime}`;
  return CryptoJS.HmacSHA256(message, secretKey).toString();
}

export function encryptPassword(password:any) {
  const publickey = _get(window, "captcha_config.publickey");
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publickey);
  return encryptor.encrypt(password);
}

export function md5EncryptAddSalt(salt: any, str: any) {
  return CryptoJS.MD5(salt + str).toString().toUpperCase();
}
